import React, {Fragment} from "react";
import {Avatar} from "@material-ui/core";
import {Link, NavLink} from "react-router-dom";
import {CgMenuGridR} from  "react-icons/cg"; 
import "../Header/Header.css";
import "../../Pages/SearchResults/SearchResults.css";
import {HiSearch} from "react-icons/hi";
import {RiVideoLine} from "react-icons/ri";
import {BsImages} from "react-icons/bs";
import logo from "../../Assets/googlelogo.png";
import SearchInput from "../SearchInput/SearchInput";
import {BiNews, BiDotsVerticalRounded, BiMap} from "react-icons/bi";
// import 
const SearchResultsHeader =()=>{
    return(
        <Fragment>
            <div className="search_results_inner">
                    {/* upper row */}
                        <div className="results_header flex-row">
                                <div className="result_nav_left flex-row">
                                   <Link to="/"><img src={logo} alt="google logo" /> </Link> 
                                    <SearchInput className="results_input" /> 
                                </div>
                            
                            <div className="result_nav_right flex-row">
                                    <CgMenuGridR className="grid-link NavLink"/>
                                    <Avatar src="" alt="profile" className="header_avatar" />
                            </div>
                        </div>
                        <div className="mobile-search-input">
                                <SearchInput id="resultsInput" className="results_input" /> 
                        </div>
                        
                        {/* bottom row */}
                        <div className="search_results_bottom_nav flex-row">
                            <div className="results_bottom_left">
                                <ul className="results_ul">
                                    <li><NavLink activeClassName="active-nav-link" to="/search-results/all"><span><HiSearch/></span> all</NavLink></li>
                                    <li><NavLink to="/search-results/images"  activeClassName="active-nav-link"><span><RiVideoLine/></span>Images</NavLink></li>
                                    <li><span><BsImages/></span>videos</li>
                                    <li><span><BiNews/></span>news</li>
                                    <li className="desktop-only"><span><BiMap/></span>maps</li>
                                    <li><span><BiDotsVerticalRounded/></span>more</li>
                                </ul>
                            </div>
                            <div className="results_bottom_right desktop-only">
                                <ul className="results_ul">
                                    <li>settings</li>
                                    <li>tools</li>
                                </ul>
                            </div>
                        </div>
                </div>
        </Fragment>
    )
}
export default SearchResultsHeader;